import { ListPanelWrapper } from '../../components/ListPaneWrapper';
import { IoCalendarOutline, IoOptionsOutline } from 'react-icons/io5';
import { useStyletron } from 'baseui';
import { ValueDisplay } from '../../components/ValueDisplay';
import { SlGraph } from 'react-icons/sl';

export function ListPanel(props: any) {
    const [, theme] = useStyletron();
    
    return (
        <ListPanelWrapper icon={<SlGraph size={'100%'}  color={theme.colors.backgroundPrimary}></SlGraph>} {...props}>
            <ValueDisplay value={props.actSetpoint} dimension={'°C'}></ValueDisplay>
        </ListPanelWrapper>
    );
}